var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6263 7.8928C14.1843 7.8928 13.826 8.25114 13.826 8.69309V14.4777C13.826 14.8133 13.553 15.0862 13.2174 15.0862H2.77165C2.43612 15.0862 2.16309 14.8133 2.16309 14.4777V4.03183C2.16309 3.6963 2.43612 3.42335 2.77165 3.42335H11.3406C11.7825 3.42335 12.1409 3.065 12.1409 2.62305C12.1409 2.1811 11.7825 1.82275 11.3406 1.82275H2.77165C1.55348 1.82275 0.5625 2.81374 0.5625 4.03183V14.4777C0.5625 15.6958 1.55348 16.6868 2.77165 16.6868H13.2174C14.4356 16.6868 15.4266 15.6958 15.4266 14.4777V8.69309C15.4266 8.25111 15.0683 7.8928 14.6263 7.8928Z",
    fill: "#65686F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 1.54842L7.16991 10.4823L4.88247 8.18662C4.57049 7.87348 4.06382 7.87264 3.75068 8.18455C3.43755 8.49652 3.43663 9.00327 3.74861 9.31633L6.29058 11.8675C6.52518 12.1032 6.8374 12.2329 7.16995 12.2329H7.17061C7.5034 12.2327 7.81577 12.1026 8.04945 11.8674L17.2042 2.67813C17.5161 2.36499 17.5152 1.85821 17.202 1.54634C16.8889 1.23437 16.3822 1.23535 16.0703 1.54842Z",
    fill: "#65686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.07705c04da73d6fbd9bba6329db18a22.svg";
export { ForwardRef as ReactComponent };